export enum ComponentId {
  IS_LEASE_CLIENT = "isLeasePlanClient",
  REDIRECT = "redirect",
  CITY_REPAIR = "city",
  COUNTRY_REPAIR = "country",
  VEHICLE_CITY = "vehicleCity",
  VEHICLE_MILEAGE = "vehicleMileage",
  VEHICLE_REGISTRATION_NUMBER = "vehicleRegistrationNumber",
  PROVINCE_REPAIR = "province",
  //JIRA LPPLWEBMOB-750
  VEHICLE_DRIVEABLE = "vehicleDriveable",
}

export enum SectionId {
  AC_VEHICLE_DRIVEABLE = "welcome-ac-vehicle-driveable",
}
